import { render, staticRenderFns } from "./CheckedIcon.vue?vue&type=template&id=23381c2a"
import script from "./CheckedIcon.vue?vue&type=script&lang=js"
export * from "./CheckedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports